import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IOwnerList } from '../../../Pages/Owner/IOwner';

interface IUpdate extends IReduxState<IOwnerList> {
  updateableDate?: IOwnerList;
}

export const UpdateOwnerSlicer = createSlice({
  name: 'UpdateOwner',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateOwner: (state, _) => {
      state.isLoading = true;
    },
    successUpdateowner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateOwner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    OwnerUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateOwnerState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateOwner,
  failureUpdateOwner,
  successUpdateowner,
  OwnerUpdateableData,
  clearUpdateOwnerState,
  clearUpdateableData,
} = UpdateOwnerSlicer.actions;

export default UpdateOwnerSlicer.reducer;
